import { render, staticRenderFns } from "./NsExpressiveLink.vue?vue&type=template&id=dc055bae&scoped=true&"
import script from "./NsExpressiveLink.vue?vue&type=script&lang=js&"
export * from "./NsExpressiveLink.vue?vue&type=script&lang=js&"
import style0 from "./NsExpressiveLink.vue?vue&type=style&index=0&id=dc055bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc055bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc055bae')) {
      api.createRecord('dc055bae', component.options)
    } else {
      api.reload('dc055bae', component.options)
    }
    module.hot.accept("./NsExpressiveLink.vue?vue&type=template&id=dc055bae&scoped=true&", function () {
      api.rerender('dc055bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsExpressiveLink.vue"
export default component.exports